/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FcmPushSubscriptionPayload } from '../models/FcmPushSubscriptionPayload';
import type { PushSubscriptionPayload } from '../models/PushSubscriptionPayload';
import type { PushUnsubscribePayload } from '../models/PushUnsubscribePayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PushNotificationsService {
    /**
     * Subscribe
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static subscribeApiPushNotificationsSubscribePost(
        requestBody: PushSubscriptionPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/push-notifications/subscribe',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unsubscribe
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unsubscribeApiPushNotificationsUnsubscribePost(
        requestBody: PushUnsubscribePayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/push-notifications/unsubscribe',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Subscribe Fcm
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static subscribeFcmApiPushNotificationsSubscribeFcmPost(
        requestBody: FcmPushSubscriptionPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/push-notifications/subscribe-fcm',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unsubscribe Fcm
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unsubscribeFcmApiPushNotificationsUnsubscribeFcmPost(
        requestBody: FcmPushSubscriptionPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/push-notifications/unsubscribe-fcm',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
